import { useState, useEffect } from 'react';
import { passengerService } from '../services/passengerService';
import toast from 'react-hot-toast';

/**
 * Hook for managing saved passengers
 */
export const useSavedPassengers = () => {
  const [savedPassengers, setSavedPassengers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch saved passengers
  const fetchSavedPassengers = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await passengerService.getAll();
      
      if (response.success) {
        setSavedPassengers(response.data || []);
      } else {
        setError(response.message || 'Failed to fetch saved passengers');
        setSavedPassengers([]);
      }
    } catch (err) {
      console.warn('Failed to fetch saved passengers:', err);
      setError('Failed to fetch saved passengers');
      setSavedPassengers([]);
      // Don't throw - just set empty array and continue
    } finally {
      setLoading(false);
    }
  };

  // Load saved passengers on mount
  useEffect(() => {
    // Silently fetch saved passengers - don't block UI if it fails
    fetchSavedPassengers().catch(err => {
      // Silently fail - this is not critical for the booking flow
      console.warn('Could not load saved passengers:', err.message);
    });
  }, []);

  // Delete saved passenger
  const deletePassenger = async (id) => {
    try {
      const response = await passengerService.delete(id);
      
      if (response.success) {
        toast.success('Passenger deleted successfully');
        // Remove from local state
        setSavedPassengers(prev => prev.filter(p => p.id !== id));
      } else {
        toast.error(response.message || 'Failed to delete passenger');
      }
    } catch (err) {
      console.error('Failed to delete passenger:', err);
      toast.error('Failed to delete passenger');
    }
  };

  return {
    savedPassengers,
    loading,
    error,
    fetchSavedPassengers,
    deletePassenger
  };
};

export default useSavedPassengers;
